import { otto, OttoNexus } from '@otto-ec/global-resources/nexus';
import './nexus-global';

export type LightboxApi = OttoNexus['ft5']['core']['lightbox'];
const lightbox: LightboxApi = otto.ft5.core.lightbox;
export const createLightbox: LightboxApi['createLightbox'] = lightbox.createLightbox;
